import type { AppCopy } from '../catalogs';

export const mtAppCopy = {
  welcomeHeading: 'Kif nista’ ngħinek illum?',
  thinking: 'Ħsieb',
  scrollToBottom: 'Skrollja għall-qiegħ',
  reasoning: 'Raġunar',
  reasoningInProgress: 'fil-progress',
  citationPages: 'Paġni {first}–{last}',
  citationTitle: 'Silta mis-sors',
  citationLoading: 'Is-sors qed jitgħabba…',
  citationUnavailable: 'It-test ikkwotat mhuwiex disponibbli jew m’għadx għandek aċċess.',
  citationOpen: 'Iftaħ is-sors',
  citationCopied: 'Ċitazzjoni kkupjata',
  copy: 'Kopja',
  more: 'Aktar',
  tryAgain: "Erġa' pprova",
  answerTruncated: 'It-tweġiba laħqet il-limitu tat-tul u nqatgħet.',
  continueAnswer: 'Kompli t-tweġiba',
  exportMarkdown: 'Esportazzjoni bħala Markdown',
  edit: 'Editja',
  cancel: 'Ikkanċella',
  update: 'Aġġornament',
  previous: 'Preċedenti',
  next: 'Li jmiss',
  messagePlaceholder: 'Ibgħat messaġġ...',
  projectHomePlaceholder: 'Chat ġdid: {project}',
  sharedChatEveryone: 'Kulħadd f’{company} jista’ jaqra dan iċ-chat',
  sharedChatOnePerson: 'Persuna waħda tista’ taqra dan iċ-chat',
  sharedChatPeople: 'Numru ta’ persuni li jistgħu jaqraw dan iċ-chat: {count}',
  forkedChatPlaceholder: 'Kompli bil-konnessjonijiet tiegħek…',
  newAnswer: 'Tweġiba ġdida',
  messageInput: 'Input tal-messaġġ',
  sendMessage: 'Ibgħat messaġġ',
  stopGenerating: 'Tieqaf tiġġenera',
  addAttachment: 'Żid it-twaħħil',
  removeFile: 'Neħħi l-fajl',
  attachmentPreview: 'Previżjoni tas-sehmu',
  imageAttachmentPreview: 'Preview tat-twaħħil tal-immaġni',
  image: 'Immaġni',
  openLink: 'rabta miftuħa',
  document: 'Dokument',
  file: 'Fajl',
  attachment: 'sekwestru',
  uploadFailed: "ittella' falla",
  uploading: 'uploading',
  toolIncomplete: 'Mhux komplut',
  toolActivity: 'Attività',
  activityThinking: 'Qed jaħseb…',
  activityWriting: 'Qed jikteb…',
  activityWaiting: 'Qed jistenna l-approvazzjoni tiegħek',
  activityStopped: 'Imwaqqaf',
  activityCouldNotFinish: 'Ma setax jitlesta',
  activitySources: 'sorsi',
  activityShowThinking: 'Uri l-ħsieb',
  activityOpen: 'Iftaħ l-attività',
  activitySteps: 'Passi',
  activitySourcesTab: 'Sorsi',
  activityUnavailable: 'Din l-attività mhix disponibbli.',
  activityInput: 'Input',
  activityOutput: 'Output',
  activityNoSources: 'Din it-tweġiba ma ċċitatx sorsi.',
  activityApprovedByReply: 'Approvata bit-tweġiba tiegħek',

  toolRunning: 'Għaddej',
  toolComplete: 'Lest',
  toolNeedsApproval: 'Jeħtieġ approvazzjoni',
  toolInput: 'Input',
  toolCall: 'sejħa għodda',
  toolCalls: 'għodda sejħiet',
  openMenu: 'Iftaħ il-menu',
  closeMenu: 'Agħlaq il-menu',
  close: 'Agħlaq',
  showInTextField: 'Uri fil-qasam tat-test',
  settings: 'Issettjar',
  appearance: 'Dehra',
  themeLight: 'Ċar',
  themeDark: 'Skur',
  themeSystem: 'Sistema',
  themeChoiceHelp:
    'Tapplika fuq it-tagħmir kollu tiegħek. Sistema ssegwi l-modalità ċara jew skura ta’ kull apparat.',
  themeSaveFailed: 'Ma stajniex nissejvjaw id-dehra, għalhekk ma nbidlitx. Erġa’ pprova.',
  toolUsed: 'Għodda użata',
  toolCancelled: 'Għodda kkanċellata',
  toolResult: 'Riżultat:',
  toolError: 'Żball:',
  toolCancelledReason: 'Raġuni kkanċellata:',
  approvalAllow: 'Ħalli',
  approvalAlwaysAllow: 'Dejjem ħalli',
  approvalDeny: 'Irrifjuta',
  approvalAlwaysDeny: 'Dejjem irrifjuta',
  approvalConfirm: 'Ikkonferma',
  approvalBack: 'Lura',
  approvalApprovedResult: 'Approvat mill-utent',
  approvalDeniedResult: 'L-utent irrifjuta l-eżekuzzjoni tal-għodda',
  logout: 'Log out',
  loginOrCreateAccount: 'Idħol / Oħloq kont',
  newChat: 'Chat ġdid',
  untitledChat: 'Chat bla titolu',
  previousChats: 'Chats preċedenti',
  openChat: 'Iftaħ iċ-chat {title}',
  moreActionsForChat: 'Aktar azzjonijiet għal {title}',
  chatActions: "Azzjonijiet ta' chat",
  closeChatActions: 'Agħlaq l-azzjonijiet taċ-chat',
  deleteChatQuestion: 'Ħassar iċ-chat?',
  deleteChatDescription: "Iċ-chat “{title}” se jitħassar b'mod permanenti.",
  deleteChat: 'Ħassar iċ-chat',
  keepChat: 'Żomm iċ-chat',
  delete: 'Ħassar',
  deleting: 'Tħassar...',
  chatDeleteFailed: "Iċ-chat ma setax jitħassar. Erġa' pprova.",
  settingsDescription: 'Ippersonalizza kif l-assistent jaħdem għalik.',
  settingsDesktopDescription: 'Ippersonalizza kif l-assistent jirrispondi lilek.',
  personalization: 'Personalizzazzjoni',
  personalizationDescription:
    "Ippersonalizza l-istruzzjonijiet li l-assistent isegwi f'kull tweġiba.",
  languageAndRegion: 'Lingwa u reġjun',
  languageAndRegionDescription: 'Agħżel il-lingwa u ż-żona tal-ħin.',
  memories: 'Memorji',
  memoriesDescription: 'Ara, editja jew ħassar dak li l-assistent jiftakar dwarek.',
  account: 'Kont',
  accountDescription: 'Immaniġġja l-kont u t-tħassir permanenti tad-dejta tiegħek.',
  backToSettings: 'Lura għall-issettjar',
  closeSettings: 'Agħlaq is-settings',
  settingsCategories: "Kategoriji ta' settings",
  yourSettings: 'Is-settings tiegħek',
  dataAndAccount: 'Data u kont',
  viewAndManageMemories: 'Ara u mmaniġġja dak li jiftakar l-assistent',
  loginToUseMemories: 'Idħol biex tuża l-memorji',
  manageOrDeleteAccount: 'Immaniġġja jew ħassar il-kont',
  unsavedChanges: 'Għandek bidliet mhux salvati',
  unsavedCloseDescription: "L-għeluq tas-settings se jarmi l-bidliet f'din il-paġna.",
  unsavedBackDescription: "Jekk tmur lura se tarmi l-bidliet f'din il-paġna.",
  continueEditing: 'Kompli editja',
  discardChanges: 'Armi l-bidliet',
  saveChanges: 'Issejvja l-bidliet',
  localSettingsNote: "Issejvjat f'dan il-browser. Idħol biex issalva fil-kont tiegħek.",
  personality: 'Personalità',
  personalityHelp: "Istruzzjonijiet personalizzati li l-assistent isegwi f'kull tweġiba",
  personalityPlaceholder:
    'Per eżempju: Kun konċiż u konkret. Jien ngħix Gothenburg u nħobb l-ikel veġetarjana.',
  timezone: 'Żona tal-ħin',
  searchTimezone: 'Fittex iż-żoni tal-ħin...',
  automaticBrowser: 'Awtomatiku (browser)',
  saved: 'Salvat {date}',
  addMemory: 'Żid memorja',
  newMemory: 'Memorja ġdida',
  memoryPlaceholder: 'Pereżempju: Nippreferi tweġibiet qosra u konkreti.',
  editMemory: 'Editja l-memorja',
  saveMemory: 'Issejvja l-memorja',
  deleteMemory: 'Ħassar il-memorja',
  memorySaveFailed: "Il-memorja ma setgħetx tiġi salvata. Erġa' pprova.",
  memoryLimitReached: "Tista' ssejvja sa 50 memorja. Ħassar waħda qabel iżżid oħra.",
  memoryInvalid: "Il-memorji ma jistgħux ikollhom links. Neħħi l-link u erġa' pprova.",
  memoryDeleteFailed: "Il-memorja ma setgħetx titħassar. Erġa' pprova.",
  memoryLoadFailed: 'Il-memorji ma setgħux jitgħabbew.',
  loadingMemories: 'Tagħbija memorji...',
  emptyMemories:
    "L-assistent jiffranka memorji dwarek waqt li titkellem — dak li tixtieq, fejn tgħix, u x'tagħmel. Tista' tarahom, teditja, u tħassarhom hawn.",
  deleteAccountHelp:
    "Ħassar b'mod permanenti l-kont u ċ-chats, memorji u settings kollha relatati.",
  deleteAccount: 'Ħassar kont',
  deleteAccountQuestion: "Ħassar il-kont b'mod permanenti?",
  deleteAccountDescription:
    "Iċ-chats, il-messaġġi, il-memorji, is-settings, u l-kredenzjali ta' dħul kollha se jitħassru. Din l-azzjoni ma tistax titneħħa.",
  deleteAccountConfirm: 'Iva, ħassar il-kont tiegħi',
  accountDeleteFailed: "Il-kont ma setax jitħassar. Xejn ma tneħħa — erġa' pprova.",
  logoutEverywhereTitle: 'L-apparati kollha',
  logoutEverywhereHelp:
    'Agħmel log out minn kull apparat u browser fejn il-kont tiegħek huwa miftuħ, inkluż dan.',
  logoutEverywhere: 'Log out minn kullimkien',
  logoutEverywhereQuestion: 'Log out mill-apparati kollha?',
  logoutEverywhereDescription:
    "Ikollok terġa' tidħol fl-apparati u l-browsers kollha, inkluż dan. Iċ-chats u s-settings tiegħek jibqgħu kif inhuma.",
  loggingOut: 'Qed isir log out…',
  logoutEverywhereFailed:
    "Ma stajniex nikkonfermaw li sar log out minn kullimkien. Erġa' pprova, jew iċċekkja fuq apparat ieħor jekk għadekx dieħel.",
  settingsSaveFailed: "Is-settings ma setgħux jiġu ssejvjati. Erġa' pprova.",
  customInstructions: 'Istruzzjonijiet tad-dwana',
  notSet: 'Mhux issettjat',
  automaticLanguage: 'Lingwa awtomatika',
  automaticTimezone: 'żona tal-ħin awtomatika',
  appLanguage: 'Lingwa tal-app',
  appLanguageHelp:
    'Jikkontrolla l-interface kollha tal-app u d-dati. It-tweġibiet tal-assistent ikomplu jsegwu l-lingwa li tikteb biha.',
  automaticBrowserLanguage: 'Awtomatiku (lingwa tal-browser)',
  previousLanguageChoice: 'Għażla preċedenti: {language} ({locale})',
  previousLanguageChoiceCode: 'Għażla preċedenti ({locale})',
  canvasCopyLink: 'Ikkopja l-link',
  canvasLinkCopied: 'Il-link ġie kkupjat',
  actionUpdatedWithEdits: 'Aġġornat bit-tibdiliet tiegħek',
  activityStepsDone: 'one:pass lest|two:passi lesti|few:passi lesti|many:pass lest|other:pass lest',
  activityResultsCount: 'one:riżultat|two:riżultati|few:riżultati|many:riżultat|other:riżultat',
  canvasCopyLinkFailed: 'Ma setax tiġi kkupjata l-link',
  canvasOpenInAgent: 'Iftaħ fl-app {agent}',
  canvasExpand: 'Espandi',
  canvasExitFullView: 'Oħroġ mill-veduta sħiħa',
  webSourceUnread:
    "Marbut f'din it-tweġiba. Poneva ma qrietx din il-paġna, allura m'hemm xejn xi jintwera hawnhekk.",
  webSourceOpenOriginal: 'Iftaħ l-oriġinal',
  toolProgressSettings: 'Qed jinbidel l-issettjar tiegħek…',
  toolProgressAgent: 'Qed jinħoloq l-aġent…',
  toolProgressConnections: 'Qed jinstabu l-għażliet ta’ konnessjoni…',
  toolProgressResult: 'Qed jitħejja r-riżultat tiegħek…',
  toolProgressClarification: 'Qed titħejja kjarifika…',
  toolProgressKnowledge: 'Qed jitħejja aġġornament issuġġerit tal-għarfien…',
  toolProgressQuestion: 'Qed titħejja mistoqsija għalik…',
  toolProgressSkill: 'Qed nagħtu forma lill-Skill tiegħek…',
  toolErrorSettings: 'L-issettjar tiegħek ma nbidilx.',
  toolErrorAgent: 'L-aġent ma setax jinħoloq.',
  toolErrorConnections: 'L-għażliet ta’ konnessjoni ma setgħux jitgħabbew.',
  toolErrorResult: 'Ir-riżultat ma ġiex salvat.',
  toolErrorClarification: 'Il-kjarifika ma setgħetx titħejja.',
  toolErrorKnowledge: 'L-aġġornament issuġġerit tal-għarfien ma setax jitħejja.',
  toolErrorQuestion: 'Il-mistoqsija ma setgħetx titħejja.',
  toolErrorSkill: 'L-abbozz tal-Skill ma setax jiġi ssejvjat.',
  toolErrorOpenSettings: 'Iftaħ Issettjar',
  toolErrorOpenAgents: 'Iftaħ Aġenti',
  toolErrorOpenConnections: 'Iftaħ Konnessjonijiet',
  toolStepIncomplete: 'Dan il-pass ma tlestiex.',
  toolEarlierAttemptsFailed:
    'one:tentattiv preċedenti ma rnexxiex|two:tentattivi preċedenti ma rnexxewx|few:tentattivi preċedenti ma rnexxewx|many:tentattiv preċedenti ma rnexxewx|other:tentattiv preċedenti ma rnexxewx',
} satisfies AppCopy;
